const LoaderGetter = {
  loaders: (state) => state.loaders
};

export default LoaderGetter;
